module.exports = __webpack_public_path__ + "img/tower2.3340828a.png";